const historySliderNav = document.querySelectorAll('[data-slider="history-module__nav"]');
const historySliderMain = document.querySelectorAll('[data-slider="history-module__slider"]');

// Thumb Slider
const historySliderNavOptions = {
  slidesPerView: 'auto',
  spaceBetween: 0,
  watchOverflow: true,
  freeMode: {
    enabled: true,
    minimumVelocity: 0.1,
    momentumBounce: true,
  },
  speed: 400,
};

historySliderNav.forEach((el) => new Swiper(el, historySliderNavOptions));

// Main Slider
const historySliderMainOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  watchOverflow: true,
  speed: 400,
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  thumbs: {
    swiper: false,
  },
};

historySliderMain.forEach((el, i) => {
  const parent = el.closest('.history-module');
  const thumbSlides = parent.querySelectorAll('.history-module__nav-item');
  historySliderMainOptions.thumbs.swiper = historySliderNav[i].swiper;
  const mainSlider = new Swiper(el, historySliderMainOptions);

  mainSlider.on('transitionStart', (swiper) => {
    const activeSlideIndex = swiper.realIndex;
    thumbSlides.forEach((slide, i) => {
      slide.classList.toggle('is-passed', i <= activeSlideIndex);
    });
  });
});
